import { Host } from '../config/index'
import Request from '@/utils/request'
import Cache from '@/utils/cache'
import Api from '@/config/api'

export function selectAjaxRemoteMethod(query, url, proxy) {
    let urlstr = false
    let map = { query: query }
    if (Object.prototype.toString.call(url) === '[object Object]') {
        urlstr = Api.AdminAjaxSelectList
        map = url
        map.query = query
    } else {
        if (url && (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1)) {
            urlstr = url
        } else {
            urlstr = Host + url
        }
    }

    return new Promise((resolve, reject) => {
        proxy.jiu.request(urlstr, map, 'GET').then((res, rej) => {
            resolve(res.data)
        }).catch((error) => {
            reject(error)
        })
    })
}
export function linkageAjaxRemoteMethod(query, url, proxy, config) {
    let urlstr = false
    let map = { query: query }
    if (Object.prototype.toString.call(url) === '[object Object]') {
        urlstr = Api.AdminAjaxLevelData
        map = url
        map.query = query
    } else {
        if (url && (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1)) {
            urlstr = url
        } else {
            urlstr = Host + url
        }
    }

    return new Promise((resolve, reject) => {
        proxy.jiu.request(urlstr, map, 'GET').then((res, rej) => {
            resolve(res.data)
        }).catch((error) => {
            reject(error)
        })
    })
}

export function getNavList(StoreNavlist, is_refresh = 0) {
    return new Promise((resolve, reject) => {
        if (!Cache.get('navList') || is_refresh) {
            Request.jiu.request(Api.AdminMenus, { pid: 1 }).then((res, rej) => {
                Cache.add('navList', res.data, 7200)
                StoreNavlist.setList(res.data)
                resolve(res.data)
            }).catch((error) => {
                reject(error)
            })
        } else {
            resolve(Cache.get('navList'))
        }
    })
}

